import cSvg from '#themes/default/default/components/svg/svg.js';

import template from './instructionStep.html' with { type: 'html' };

export default {
	name: 'CInstructionStep',
	components: {
		cSvg
	},
	props: {
		headline: {
			type: String,
			required: true
		},
		iconNumber: {
			type: Number,
			default: 1
		},
		text: {
			type: String,
			default: ''
		}
	},
	computed: {
		stepIcon() {
			return `#instruction-number${this.iconNumber}`;
		}
	},
	template
};
